type PaginationProps = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let index = 1; index <= totalPages; index += 1) {
    pages.push(index);
  }

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="h-9 px-3 rounded-md border border-background-300/70 text-xs text-foreground-600 flex items-center gap-1 cursor-pointer hover:border-primary-500 hover:text-accent-500 transition-colors disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((item) => (
        <button
          key={item}
          type="button"
          onClick={() => onChange(item)}
          className={`w-9 h-9 rounded-md text-xs cursor-pointer transition-colors ${
            item === page
              ? "bg-primary-500 text-foreground-950"
              : "border border-background-300/70 text-foreground-600 hover:border-primary-500 hover:text-accent-500"
          }`}
        >
          {item}
        </button>
      ))}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="h-9 px-3 rounded-md border border-background-300/70 text-xs text-foreground-600 flex items-center gap-1 cursor-pointer hover:border-primary-500 hover:text-accent-500 transition-colors disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}